<template>
  <div class="inventory_records">
    <van-sticky>
      <van-search
        v-model="itemNameLike"
        shape="round"
        show-action
        background="#F8D541"
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="isLoading"
        :finished="finished"
        finished-text="没有更多数据"
        @load="onLoad"
      >
      <div class="list_li">
        <ul>
          <li class="item van-hairline--bottom">
            <p>商品名称</p>
            <p>图片</p>
            <p>颜色尺寸</p>
            <p>库存变量</p>
            <p>操作人</p>
            <p>操作时间</p>
          </li>
          <li v-for="(item,index) in list" :key="index" class="item val  van-hairline--bottom">
            <p>{{item.itemName}}</p>
            <van-image width="40" height="40" :src="item.skuImage.imageUrl" />
            <p>{{item.attribute}}</p>
            <p>{{item.count}}</p>
            <p class="van-ellipsis">{{item.creator}}</p>
            <p>{{item.recordTime}}</p>
          </li>
        </ul>
      </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import http from "@/utils/axios";
export default {
  data() {
    return {
      itemNameLike: "",
      pageIndex: 1,
      list:[],
      refreshing: false,
      isLoading: false,
      finished: false
    };
  },
  methods: {
    onLoad(){
      this.getData();
    },
    getData() {
      http({
        url: "/item/item/quick/bess/stockRecord/page",
        method: "POST",
        parmes: {
          pageIndex: this.pageIndex,
          pageSize: 10,
          itemNameLike: this.itemNameLike
        }
      }).then(rps => {
        if(rps.code===200){
          if(rps.data.length==0){
            this.finished=true;
          }else{
            this.pageIndex++;
            this.isLoading=false;
          }
          this.list = this.list.concat(rps.data)
        }
      });
    },
    onSearch() {
      this.pageIndex=1;
      this.list=[];
      this.getData();
    },
    onCancel() {
      this.pageIndex=1;
      this.list=[];
      this.getData();
    },
    onRefresh(){
      setTimeout(()=>{
        this.refreshing =false;
        this.pageIndex=1;
      this.list=[];
      this.getData();
      },2000)
      
    }
  },
  created(){
    this.$loading.hide();
  }
};
</script>
<style lang="less" scoped>
  .inventory_records{
    .list_li{
      padding: 20px;
      background: #fff;
      .item{
        font-size: 22px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        text-align: center;
        p{
           width: calc( 100% /6);
           text-align: center;
        }
      }
      .val{
        padding:  10px 0;
        p{
          margin: 5px 0;
         
        }
      }
    }
  }
</style>